import { httpInterceptor } from '../http-interceptor';

export class ShipmentService {
  static ENDPOINTS = {
    GET_ALL: 'shipment/getall',
    GET_ALL_PAGED: 'shipment/getallpaged',
    CREATE: 'shipment/saveshipment',
    UPDATE: 'shipment/update',
    DELETE: 'shipment/delete',
    GET_BY_ID: 'shipment/getshipmentbyid',
    GET_BY_ASP: 'shipment/getshipmentbyasp',
    GET_SHIP_DOC: 'shipment/shipdoc',
    GET_SHIP_PHOTOS: 'shipment/shipphotos',
    IMPORT_SHIPMENT: 'shipment/uploadshipment',
    DOWNLOAD: 'shipment/download',
    OPERATION: 'Mobile/saveprintrequest',
    PACKING_SLIP: 'report/packingslip',
    PICK_TICKET: 'report/pickticket'
  };

  static async getAllShipments(data) {
    return httpInterceptor.post(this.ENDPOINTS.GET_ALL, data);
  }

  static async getAllShipmentsPaged(data) {
    return httpInterceptor.post(this.ENDPOINTS.GET_ALL_PAGED, data);
  }

  static async getShipmentById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${id}`);
  }

  static async getShipmentByAsp(aspNumber) {
    const asp = encodeURIComponent(String(aspNumber ?? '').trim());
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ASP}/${asp}`);
  }

  /**
   * Get OneDrive ship PDF by ASP number ({asp}.pdf in Ship_Doc_Uploads).
   * Response.response: { exists, aspNum, fileName, fileBase64, webUrl }
   */
  static async getShipDocByAsp(aspNum) {
    const asp = encodeURIComponent(String(aspNum ?? '').trim());
    return httpInterceptor.get(`${this.ENDPOINTS.GET_SHIP_DOC}/${asp}`);
  }

  /**
   * Get OneDrive checkout photos by ASP from Ship_Photo_Uploads.
   * Matches {asp}.jpg and {asp}(n).jpg (also jpeg/png/webp/gif).
   * Response.response: { aspNum, count, photos: [{ fileName, fileBase64, contentType, webUrl }] }
   */
  static async getShipPhotosByAsp(aspNum) {
    const asp = encodeURIComponent(String(aspNum ?? '').trim());
    return httpInterceptor.get(`${this.ENDPOINTS.GET_SHIP_PHOTOS}/${asp}`);
  }

  static async createShipment(data) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE, data);
  }

  static async doOperationOnShipment(data){
    return httpInterceptor.post(this.ENDPOINTS.OPERATION, data);
  }

  static async downloadPackingSlip(shipmentId, aspNumber) {
    try {
      const response = await fetch(`${httpInterceptor.baseUrl}${this.ENDPOINTS.PACKING_SLIP}/${shipmentId}/${aspNumber}`, {
        method: 'GET',
        headers: httpInterceptor.getAuthHeaders()
      });

      if (!response.ok) {
        throw new Error('Failed to download packing slip');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `PackingSlip_${aspNumber}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      return { status: 200 };
    } catch (error) {
      httpInterceptor.handleError(error);
      throw error;
    }
  }

  static async downloadPickTicket(shipmentId, aspNumber) {
    try {
      const response = await fetch(`${httpInterceptor.baseUrl}${this.ENDPOINTS.PICK_TICKET}/${shipmentId}/${aspNumber}`, {
        method: 'GET',
        headers: httpInterceptor.getAuthHeaders()
      });

      if (!response.ok) {
        throw new Error('Failed to download pick ticket');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `PickTicket_${aspNumber}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      return { status: 200 };
    } catch (error) {
      httpInterceptor.handleError(error);
      throw error;
    }
  }

  static async importShipment(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.IMPORT_SHIPMENT, data);
  }

  static async updateShipment(id, data) {
    return httpInterceptor.put(`${this.ENDPOINTS.UPDATE}/${id}`, data);
  }

  static async deleteShipment(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }

  static async downloadShipment(data) {
    return httpInterceptor.post(`${this.ENDPOINTS.DOWNLOAD}`, data);
  }
}
